import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Zap, Sparkles } from "lucide-react";

export default function Cta() {
  return (
    <section className="bg-zinc-950 text-white relative overflow-hidden py-24 md:py-32">
      {/* Glow Effects */}
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 50%, rgba(245, 158, 11, 0.15) 0%, rgba(9, 9, 11, 0) 70%)",
        }}
      />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
        >
          <div className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-amber-400 bg-amber-950/60 border border-amber-800/60 px-3.5 py-1.5 rounded-full mb-6">
            <Sparkles className="h-3.5 w-3.5" /> Start Free in 3 Minutes
          </div>

          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl text-white tracking-tight">
            Stop throwing money in the bin. Start forecasting today.
          </h2>

          <p className="text-base sm:text-lg text-zinc-400 mt-6 max-w-2xl mx-auto leading-relaxed">
            Join café owners who use Optics to plan with their sales, weather and events — so they
            eliminate stockouts and stop guessing their daily orders.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-zinc-950 px-8 py-4 rounded-xl font-bold text-sm transition-all duration-200 shadow-xl shadow-emerald-950 hover:-translate-y-0.5"
            >
              Start 14-Day Free Trial <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-xs text-zinc-400 font-medium">
            <span className="flex items-center gap-1.5">
              <ShieldCheck className="h-4 w-4 text-emerald-400" /> 14-day free trial · card required · cancel anytime
            </span>
            <span className="flex items-center gap-1.5">
              <Zap className="h-4 w-4 text-amber-400" /> Instant POS integration
            </span>
            <span className="flex items-center gap-1.5">
              <span>Prices in NZD · Cancel anytime</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
